module.exports = __webpack_public_path__ + "static/img/free_lessons.bd91d0a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/free_lessons.png
// module id = AEbW
// module chunks = 1